export default __webpack_public_path__ + "static/media/wbtc.c64cb803.png";